import {buildCommentPermalink} from '../../utils/helpers';
import {useAppContext} from '../../app-context';

type Props = {
    isFirst: boolean,
    isPaid: boolean,
    commentId?: string
};

const CTABox: React.FC<Props> = ({isPaid, commentId}) => {
    const {member, t} = useAppContext();

    const handleSignUpClick = () => {
        window.location.href = (isPaid && member) ? '#/portal/account/plans' : '#/portal/signup';
    };

    const handleSignInClick = () => {
        if (commentId) {
            const redirect = new URL(window.location.href);
            redirect.hash = buildCommentPermalink(commentId);
            window.location.href = `#/portal/signin?redirect=${encodeURIComponent(redirect.toString())}`;
            return;
        }
        window.location.href = '#/portal/signin';
    };

    return (
        <div className="gh-cta-box w-full" style={{padding: '20px 0 12px'}}>
            <div
                style={{
                    border: '1px solid var(--input-border)',
                    borderRadius: '8px',
                    padding: '16px 18px',
                    color: 'var(--muted)',
                    fontSize: '16px',
                    lineHeight: 1.5,
                    cursor: 'pointer'
                }}
                onClick={handleSignUpClick}
            >
                {t('Write a comment…')}
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: '14px', marginTop: '18px', flexWrap: 'wrap'}}>
                <button
                    data-testid="signup-button"
                    style={{
                        background: 'var(--fg)',
                        color: 'var(--bg)',
                        fontWeight: 500,
                        fontSize: '16px',
                        padding: '12px 24px',
                        borderRadius: '6px',
                        border: 'none',
                        cursor: 'pointer'
                    }}
                    type="button"
                    onClick={handleSignUpClick}
                >
                    {(isPaid && member) ? t('Upgrade now') : t('Sign up to comment')}
                </button>
                {!member && (
                    <span style={{fontSize: '15px', color: 'var(--muted)'}}>
                        {t('Already a member?')}{' '}
                        <button
                            data-testid="signin-button"
                            style={{
                                color: 'var(--fg)',
                                fontWeight: 600,
                                textDecoration: 'underline',
                                textUnderlineOffset: '3px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '15px',
                                padding: 0
                            }}
                            type="button"
                            onClick={handleSignInClick}
                        >
                            {t('Sign in')}
                        </button>
                    </span>
                )}
            </div>
        </div>
    );
};

export default CTABox;
